import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, Typography } from '@mui/material';
import { Modal } from '../../../../widgets';

const PanelNotasView = () => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const panelNotasStore = Redux.useSelector((state) => state.panelNotas);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container>
      {/* <Grid container sx={{ mb: 2 }}> */}
      {/* <AlertWidget alert={panelNotasStore.alertView} />

        <BotonComponent
          click={async () => {
            await setActivoPanelNotasAction(dispatch, null);
            setOpenModalForm(true);
          }}
          blue
          mr={2}
        />
        {panelNotasStore.all.length > 0 ? (
          <BotonComponent
            click={async () => {
              await setActivoPanelNotasAction(dispatch, null);
              await allPanelNotasAction(
                dispatch,
                entidadesStore.activo.id,
                null
              );
            }}
            disabled={panelNotasStore.loadingAll}
            white
            text={
              panelNotasStore.loadingAll ? "Actualizando..." : "Actualizar"
            }
          />
        ) : null}
      </Grid>
      <ListadoPanelNotas setOpenModalForm={(val) => setOpenModalForm(val)} />

      <Modal
        id="modalFormPanelNotas"
        title={`${panelNotasStore.activo ? "Editar" : "Nuevo"} documento`}
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        {panelNotasStore.activo ? (
          <Typography variant="h6">
            {panelNotasStore.activo.nombres} {panelNotasStore.activo.apellidos}
          </Typography>
        ) : null}
        <FormPanelNotas
          activo={panelNotasStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Modal> */}
    </Grid>
  );
};

export default PanelNotasView;
